import React from 'react'
import Text from '../text/Text'
import SvgIcon from '../svgIcon/SvgIcon'
import { MenuStyles } from './MenuStyles'

export interface MenuProperties {
    responsive?: boolean
    onMenu?: () => void
    onSuscription?: () => void
    onChat?: () => void
}

export function MenuComponent(properties: MenuProperties) {
    return (
        <div style={MenuStyles.container}>
            <div>
                {properties.responsive && (
                    <button
                        onClick={properties.onMenu}
                        style={MenuStyles.menuContainer}
                    >
                        <div style={MenuStyles.menuIconItem} />
                        <div style={MenuStyles.menuIconItem} />
                        <div style={MenuStyles.menuIconItem} />
                    </button>
                )}
            </div>
            <div style={MenuStyles.itemsContent}>
                {properties.onSuscription && (
                    <>
                        <div style={MenuStyles.ml10}>
                            <button
                                onClick={properties.onSuscription}
                                style={MenuStyles.suscriptionBtn}
                            >
                                <Text
                                    color="#fff"
                                    fontSize={14}
                                    fontWeight={400}
                                    marginRight={10}
                                    label="Mejora tu plan"
                                />
                                <SvgIcon iconName="IconPadlockWhite" />
                            </button>
                        </div>
                        <div style={MenuStyles.divider} />
                    </>
                )}
                {/*   {properties.onChat && (
                    <div style={MenuStyles.ml10}>
                        <button
                            onClick={properties.onChat}
                            style={MenuStyles.chatBtn}
                        >
                            <div style={MenuStyles.chatBtnIconContainer}>
                                <SvgIcon iconName="IconChatWhite" />
                            </div>
                            <Text
                                color="#fff"
                                fontSize={13}
                                fontWeight={500}
                                label="Canal de comunicaciones"
                            />
                        </button>
                    </div>
                )} */}
                <div style={MenuStyles.divider} />
                <div style={MenuStyles.flagsContainer}>
                    <div style={MenuStyles.flagContainer}>
                        <SvgIcon iconName="Chile" width={18} height={18} />
                    </div>
                    <div style={MenuStyles.imageCircleContainer}></div>
                </div>
            </div>
        </div>
    )
}
